// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../delivery-no-documents/state/report';
import actions from '../../actions-list';

const updateDeliveryNoDocumentsReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_DELIVERY_NO_DOCUMENTS_REPORT_SUCCESS]: updateDeliveryNoDocumentsReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateDeliveryNoDocumentsReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/delivery-no-documents/reducers/report.js